import { Component, type ErrorInfo, type ReactNode } from "react";
import { ErrorPage } from "@/pages/error";

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { error: null };
    }

    public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Unhandled UI error", error, errorInfo);
    }

    private handleRetry = () => {
        this.setState({ error: null });
    };

    public render() {
        if (this.state.error) {
            return <ErrorPage onRetry={this.handleRetry} />;
        }

        return this.props.children;
    }
}
